import { render, staticRenderFns } from "./ChangelogEntry.vue?vue&type=template&id=abe3e686&"
import script from "./ChangelogEntry.vue?vue&type=script&lang=ts&"
export * from "./ChangelogEntry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports